import AmusnetIcon from '@/assets/icon/svg/system-message/amusnet.svg'
import AviatrixIcon from '@/assets/icon/svg/system-message/aviatrix.svg'
import BetgamesIcon from '@/assets/icon/svg/system-message/betgames.svg'
import BetsolutionsIcon from '@/assets/icon/svg/system-message/betsolutions.svg'
import BoldplayIcon from '@/assets/icon/svg/system-message/boldplay.svg'
import CashbackIcon from '@/assets/icon/svg/system-message/cashback-msg.svg'
import EndorphinaIcon from '@/assets/icon/svg/system-message/endorphina.svg'
import ErrorIcon from '@/assets/icon/svg/system-message/error.svg'
import GamzixIcon from '@/assets/icon/svg/system-message/gamzix.svg'
import GiftIcon from '@/assets/icon/svg/system-message/gift-msg.svg'
import InfoIcon from '@/assets/icon/svg/system-message/info.svg'
import LivecashbackIcon from '@/assets/icon/svg/system-message/livecashback.svg'
import PaymentIcon from '@/assets/icon/svg/system-message/payment.svg'
import PlayngoIcon from '@/assets/icon/svg/system-message/playngo.svg'
import PragmaticIcon from '@/assets/icon/svg/system-message/pragmatic.svg'
import SpecoperationIcon from '@/assets/icon/svg/system-message/specoperation.svg'
import SuccessIcon from '@/assets/icon/svg/system-message/success.svg'
import TournamentsIcon from '@/assets/icon/svg/system-message/tournaments.svg'
import WarningIcon from '@/assets/icon/svg/system-message/warning.svg'

export const SYSTEM_MESSAGE_ICONS = Object.freeze({
  success: SuccessIcon,
  error: ErrorIcon,
  info: InfoIcon,
  warning: WarningIcon,
  tournaments: TournamentsIcon,
  'gift-msg': GiftIcon,
  payment: PaymentIcon,
  specoperation: SpecoperationIcon,
  'cashback-msg': CashbackIcon,
  aviatrix: AviatrixIcon,
  betgames: BetgamesIcon,
  endorphina: EndorphinaIcon,
  pragmatic: PragmaticIcon,
  livecashback: LivecashbackIcon,
  gamzix: GamzixIcon,
  amusnet: AmusnetIcon,
  boldplay: BoldplayIcon,
  betsolutions: BetsolutionsIcon,
  playngo: PlayngoIcon,
})
